module.exports = __webpack_public_path__ + "img/munka2.ce8f6c62.jpg";